import RoleStore from "./administrator/roleStore"
import UserStore from "./administrator/userStore"
import SessionStore from "./sessionStore"
import AuthenticationStore from "./authenticationStore"
import AccountStore from "./accountStore"
import LanguageStore from "./administrator/languageStore"

import FileStore from "./common/fileStore"
import CommentStore from "./common/commentStore"
import NotificationTemplateStore from "./notificationTemplate/notificationTemplateStore"

import MasterDataStore from "@stores/master-data/masterDataStore"
import AppDataStore from "./appDataStore"

import CompanyStore from "./clientManagement/companyStore"

import ActivityStore from "./activity/activityStore"
import ProposalStore from "./activity/proposalStore"
import SiteVisitStore from "./activity/siteVisitStore"

import UnitStore from "./projects/unitStore"
import InquiryStore from "./communication/inquiryStore"

import OrganizationUnitStore from "./organizationUnit/organizationUnitStore"
import CustomerStore from "./customer/customerStore"
import CustomerPotentialStore from "./customer/customerPotentialStore"
import FilterStore from "./filter/filterStore"
import AgencyMasterStore from "./agencyMaster/agencyMasterStore"
import AgencyMasterGroupStore from "./agencyMasterGroup/agencyMasterGroupStore"
import ImportStore from "./common/importStore"
import PinkBookStore from "./pinkBook/pinkBookStore"
import ApprovalStore from "./approval/approvalStore"

import TowerStore from "./master-data/towerStore"
import CustomerSourceStore from "./master-data/customerSourceStore"
import ProjectFacilityStore from "./master-data/projectFacilityStore"
import TownShipStore from "./master-data/townShipStore"
import TownshipAreaStore from "./master-data/townshipAreaStore"
import UnitDesignStore from "./master-data/unitDesignStore"
import UnitFacilityStore from "./master-data/unitFacilityStore"
import UnitTypeStore from "./master-data/unitTypeStore"
import ProjectMasterStore from "./master-data/projectMasterStore"
import UnitMasterStore from "./master-data/unitMasterStore"
import ZoneStore from "./master-data/zoneStore"
import FloorStore from "./master-data/floorStore"
import PaymentMasterStore from "./master-data/paymentMasterStore"
import PropertyTypeStore from "./master-data/propertyTypeStore"
import ViewStore from "./master-data/viewStore"
import PaymentRequestStore from "./master-data/paymentRequestStore"
import AccountTypeStore from "./master-data/accountingData/accountTypeStore"
import AccountingDocumentTypeStore from "./master-data/accountingData/accountingDocumentTypeStore"
import CostCenterStore from "./master-data/accountingData/costCenterStore"
import OffsetAccountStore from "./master-data/accountingData/offsetAccountStore"

import TradingFloorStore from "./floorStaff/tradingFloorStore"
import BussinessTargetStore from "./floorStaff/bussinessTargetStore"
import AllocatedCustomerStore from "./floorStaff/allocatedCustomerStore"
import FloorStaffStore from "./floorStaff/floorStaffStore"

import FeeTypeStore from "./feeType/FeeTypeStore"
import PhaseCodeStore from "./phaseCode/phaseCodeStore"
import SystemConfigurationStore from "./system/SystemConfigurationStore"
import ApprovalProcessStore from "./approvalProcess/approvalProcessStore"
import ConfigHolidayStore from "./configHoliday/configHolidayStore"
import BlockUserStore from "./blockUser/blockUserStore"

export default function initializeStores() {
  return {
    authenticationStore: new AuthenticationStore(),
    roleStore: new RoleStore(),
    userStore: new UserStore(),
    sessionStore: new SessionStore(),
    accountStore: new AccountStore(),
    languageStore: new LanguageStore(),
    appDataStore: new AppDataStore(),

    fileStore: new FileStore(),
    commentStore: new CommentStore(),
    notificationTemplateStore: new NotificationTemplateStore(),

    masterDataStore: new MasterDataStore(),

    companyStore: new CompanyStore(),

    activityStore: new ActivityStore(),
    proposalStore: new ProposalStore(),
    siteVisitStore: new SiteVisitStore(),

    unitStore: new UnitStore(),
    inquiryStore: new InquiryStore(),

    organizationUnitStore: new OrganizationUnitStore(),

    // Master store
    customerSourceStore: new CustomerSourceStore(),
    projectFacilityStore: new ProjectFacilityStore(),
    townShipStore: new TownShipStore(),
    townshipAreaStore: new TownshipAreaStore(),
    unitDesignStore: new UnitDesignStore(),
    unitFacilityStore: new UnitFacilityStore(),
    unitTypeStore: new UnitTypeStore(),
    projectMasterStore: new ProjectMasterStore(),
    unitMasterStore: new UnitMasterStore(),
    towerStore: new TowerStore(),
    zoneStore: new ZoneStore(),
    paymentMasterStore: new PaymentMasterStore(),
    propertyTypeStore: new PropertyTypeStore(),
    viewStore: new ViewStore(),
    paymentRequestStore: new PaymentRequestStore(),
    floorStore: new FloorStore(),

    // Accounting Data
    accountTypeStore: new AccountTypeStore(),
    accountingDocumentTypeStore: new AccountingDocumentTypeStore(),
    costCenterStore: new CostCenterStore(),
    offsetAccountStore: new OffsetAccountStore(),

    // CRM
    filterStore: new FilterStore(),
    importStore: new ImportStore(),
    pinkBookStore: new PinkBookStore(),
    approvalStore: new ApprovalStore(),
    customerStore: new CustomerStore(),
    customerPotentialStore: new CustomerPotentialStore(),

    // Trading Floor
    agencyMasterStore: new AgencyMasterStore(),
    agencyMasterGroupStore: new AgencyMasterGroupStore(),

    // Floor and Staff
    tradingFloorStore: new TradingFloorStore(),
    floorStaffStore: new FloorStaffStore(),
    bussinessTargetStore: new BussinessTargetStore(),
    allocatedCustomerStore: new AllocatedCustomerStore(),

    // Fee
    feeTypeStore: new FeeTypeStore(),

    // Phase / Config
    phaseCodeStore: new PhaseCodeStore(),
    systemConfigurationStore: new SystemConfigurationStore(),
    approvalProcessStore: new ApprovalProcessStore(),
    configHolidayStore: new ConfigHolidayStore(),
    blockUserStore: new BlockUserStore(),
  }
}
